/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_ExampleInputs */

const en_mk_team_example = /** @type {(inputs: Mk_Team_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example workflow for two independent tasks`)
};

const id_mk_team_example = /** @type {(inputs: Mk_Team_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contoh alur dua tugas yang bisa berjalan bersamaan`)
};

/**
* | output |
* | --- |
* | "Example workflow for two independent tasks" |
*
* @param {Mk_Team_ExampleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_example = /** @type {((inputs?: Mk_Team_ExampleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_ExampleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_example(inputs)
	return en_mk_team_example(inputs)
});